module.exports = __webpack_public_path__ + "static/contact_big_img-22eaaa97fb0fd2a4f6176eb71efa7c69.png";